// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import { getMenuItems } from 'menu-items';
import { useAuth } from 'contexts/AuthContext';
import useSuggestionsPendingCount from 'hooks/useSuggestionsPendingCount';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const { isPlatformAdmin } = useAuth();
  const suggestionsPendingCount = useSuggestionsPendingCount(isPlatformAdmin);
  const menuItem = getMenuItems({ isPlatformAdmin, suggestionsPendingCount });

  const navGroups = menuItem.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}